<app-payment-panel-paygreen-generic type="PAYGREEN_LUNCHR"></app-payment-panel-paygreen-generic>
